var ButtonSizes;
(function (ButtonSizes) {
    ButtonSizes["EXTRA_SMALL"] = "extra-small";
    ButtonSizes["SMALL"] = "small";
    ButtonSizes["REGULAR"] = "regular";
    ButtonSizes["LARGE"] = "large";
})(ButtonSizes || (ButtonSizes = {}));
var ButtonIconSizes;
(function (ButtonIconSizes) {
    ButtonIconSizes["EXTRA_SMALL"] = "extra-small";
    ButtonIconSizes["SMALL"] = "small";
})(ButtonIconSizes || (ButtonIconSizes = {}));
var ButtonApplication;
(function (ButtonApplication) {
    ButtonApplication["NORMAL"] = "normal";
    ButtonApplication["OVER_IMAGE"] = "overImage";
})(ButtonApplication || (ButtonApplication = {}));
var IconPosition;
(function (IconPosition) {
    IconPosition["LEFT"] = "left";
    IconPosition["RIGHT"] = "right";
})(IconPosition || (IconPosition = {}));
var InputStatusType;
(function (InputStatusType) {
    InputStatusType["Default"] = "default";
    InputStatusType["Error"] = "error";
    InputStatusType["Success"] = "success";
})(InputStatusType || (InputStatusType = {}));
var InputSizes;
(function (InputSizes) {
    InputSizes["SMALL"] = "small";
    InputSizes["REGULAR"] = "regular";
})(InputSizes || (InputSizes = {}));
var ChipSizes;
(function (ChipSizes) {
    ChipSizes["REGULAR"] = "regular";
    ChipSizes["LARGE"] = "large";
})(ChipSizes || (ChipSizes = {}));
var InitialAvatarSizes;
(function (InitialAvatarSizes) {
    InitialAvatarSizes["EXTRA_SMALL"] = "extra-small";
    InitialAvatarSizes["SMALL"] = "small";
    InitialAvatarSizes["MEDIUM"] = "medium";
    InitialAvatarSizes["LARGE"] = "large";
})(InitialAvatarSizes || (InitialAvatarSizes = {}));
var InitialAvatarBorderRadius;
(function (InitialAvatarBorderRadius) {
    InitialAvatarBorderRadius["NONE"] = "none";
    InitialAvatarBorderRadius["EXTRA_SMALL"] = "extra-small";
    InitialAvatarBorderRadius["SMALL"] = "small";
    InitialAvatarBorderRadius["MEDIUM"] = "medium";
    InitialAvatarBorderRadius["LARGE"] = "large";
    InitialAvatarBorderRadius["EXTRA_LARGE"] = "extra_large";
    InitialAvatarBorderRadius["MAX"] = "max";
})(InitialAvatarBorderRadius || (InitialAvatarBorderRadius = {}));

export { ButtonApplication, ButtonIconSizes, ButtonSizes, ChipSizes, IconPosition, InitialAvatarBorderRadius, InitialAvatarSizes, InputSizes, InputStatusType };
//# sourceMappingURL=types.js.map
